import { useEffect, useRef } from 'react';

/**
 * When the virtual keyboard opens (visualViewport shrinks on mobile),
 * scrolls the anchor element into view so input fields and buttons stay visible.
 * Use in components with text input inside a scrollable study card.
 */
export function useKeyboardScroll(shouldActivate: boolean) {
  const anchorRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!shouldActivate) return;

    const scrollToAnchor = () => {
      setTimeout(() => {
        anchorRef.current?.scrollIntoView({ block: 'end', behavior: 'smooth' });
      }, 100);
    };

    window.visualViewport?.addEventListener('resize', scrollToAnchor);

    // Also scroll once immediately in case keyboard is already open
    scrollToAnchor();

    return () => {
      window.visualViewport?.removeEventListener('resize', scrollToAnchor);
    };
  }, [shouldActivate]);

  return anchorRef;
}
